import Splide from '@splidejs/splide';


new Splide( '.splide', {
    perPage: 3,
    gap: 15,
    lazyLoad: 'nearby',
    pagination: false,
    breakpoints: {
		767: {
			perPage: 1,
		},
        1024: {
            perPage: 2
        }
  }
}).mount();
